import { render, staticRenderFns } from "./LeadServiceLineNotices.vue?vue&type=template&id=60dee378&"
import script from "./LeadServiceLineNotices.vue?vue&type=script&lang=js&"
export * from "./LeadServiceLineNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports